import React from "react";
import "./Contact.css";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { theamContex } from "../../Context";
import { useContext } from "react";

function Contact() {
  const theme = useContext(theamContex);
  const darkMode = theme.state.darkMode;

  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [msg, setMsg] = useState("");

  const form = useRef();
  const [done, setDone] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    if (user.length > 4 || pass.length > 6 || msg > 10) {
      emailjs
        .sendForm(
          "service_qhnbc12",
          "template_aovfawb",
          form.current,
          "iJzGvO6xzVlCUNq_k"
        )
        .then((result) => {
          setDone(true);
          alert("I will get back soon");
        });
    } else {
      alert("Invalid")
      setDone(false);
    }
  };

  function userHandler(e) {
    const item = e.target.value;
    if (item.length === 0) {
      console.log("name Not valid");
    }
    setUser(item);
  }
  function passHandler(e) {
    const item = e.target.value;
    if (item.length === 0) {
      console.log("name Not valid");
    }
    setPass(item);
  }
  function msgHandler(e) {
    const item = e.target.value;
    if (item.length === 0) {
      console.log("name Not valid");
    }
    setMsg(item);
  }

  
  function handleClick() {
    const firstNameInput = document.getElementById("name");
    const mail = document.getElementById("mail");
    const msg = document.getElementById("msg");


    // console.log(firstNameInput.value);
    // 👇️ clear input field
    firstNameInput.value = "";
    mail.value = "";
    msg.value = "";

  };

  return (
    <div
      id="Contact"
      className="contact"
      style={{
        background: darkMode ? "black" : "",
        color: darkMode ? "white" : "",
      }}
    >
      <div className="contact-left">
        <div className="info">
          <span>Get In Touch</span>
          <span>Contact Me</span>
        </div>
      </div>
      <div className="blur-1"></div>
      <div className="contact-right">
        <form ref={form} onSubmit={sendEmail}>
          <input
          id="name"
            type="text"
            name="to_name"
            className="user"
            placeholder="Name"
            onChange={userHandler}
          />

          <input
          id="mail"
            type="email"
            name="from_name"
            className="user"
            placeholder="Email"
            onChange={passHandler}
          />

          <textarea
          id="msg"
            name="message"
            className="user"
            placeholder="Message"
            onChange={msgHandler}
          ></textarea>

          <input id='btn' type="submit" value="Send" className="button" onClick={handleClick}/>
            {/* <span id="thx">{done ? "Thank" : ""} </span> */}
          
        </form>
        <div
          className="blur"
          style={{ backgroundColor: "orange", filter: "blur(200px)" }}
        ></div>
      </div>
    </div>
  );
}

export default Contact;
